__turbopack_context__.v({
  "avatar": "index-module__L07hAW__avatar",
  "item": "index-module__L07hAW__item",
  "medium": "index-module__L07hAW__medium",
  "small": "index-module__L07hAW__small",
  "wrapper": "index-module__L07hAW__wrapper",
});
